import { DrinkPairingRow } from '../lib/pairingService';

interface Props {
  results: DrinkPairingRow[];
}

export default function DrinkPairingResults({ results }: Props) {
  if (!results || results.length === 0) return null;

  return (
    <div className="card" style={{ marginTop: '0.75rem' }}>
      <h3 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Recommended Drinks</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0.75rem' }}>
        {results.slice(0, 4).map((r) => (
          <div key={r.drink_id} style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
            <div
              style={{
                width: '56px',
                height: '56px',
                backgroundColor: '#5a3310',
                borderRadius: '8px',
                overflow: 'hidden',
                flexShrink: 0
              }}
            >
              {r.image_url ? (
                <img src={r.image_url} alt={r.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <div style={{ width: '100%', height: '100%' }} />
              )}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.5rem' }}>
                <div>
                  <div style={{ fontWeight: 600 }}>{r.name}</div>
                  {r.drink_type && (
                    <div style={{ fontSize: '0.75rem', color: '#999', marginTop: '0.125rem' }}>{r.drink_type}</div>
                  )}
                </div>
                <div style={{ fontSize: '0.75rem', color: '#d3de5e' }}>
                  {(Math.max(0, Math.min(1, r.score)) * 100).toFixed(0)}%
                </div>
              </div>
              {r.description && (
                <div style={{ fontSize: '0.75rem', color: '#999', marginTop: '0.25rem' }}>{r.description}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}










